import { ButtonText } from '@/ui/core/button'
import { VStack } from '@/ui/core/stack'
import { cn } from '@/ui/utils'
import { Pressable } from 'react-native'
import { slotDateButtonStyles } from './SlotDateButton.styles'
import type { SlotDateButtonProps } from './SlotDateButton.types'

export const SlotDateButton = ({
	slotDate,
	isSelected,
	onPressed,
	isFirst,
	isLast,
}: SlotDateButtonProps) => {
	const slotDateSplit = slotDate.split(' ')
	const { slotButtonContainer, slotDayOfWeek, slotDateDay, slotDateMonth } =
		slotDateButtonStyles()

	return (
		<Pressable
			role="button"
			onPress={() => onPressed(slotDate)}
			className={cn(
				slotButtonContainer(),
				isSelected ? 'bg-palette_5' : 'bg-palette_2',
				isFirst && 'border-l-2',
				isLast && 'border-r-2'
			)}
		>
			<ButtonText className={cn(slotDayOfWeek())}>{slotDateSplit[0]}</ButtonText>
			<VStack className="space-between">
				<ButtonText className={cn(slotDateDay())}>{slotDateSplit[1]}</ButtonText>
				<ButtonText className={cn(slotDateMonth())}>{slotDateSplit[2]}</ButtonText>
			</VStack>
		</Pressable>
	)
}
